import React, { FC } from 'react'
import CommonGrid from '@mailstep/design-system/ui/Blocks/CommonGrid'
import GridExport, { Props as GridExportProps } from '@components/blocks/GridExport'
import { GridProps } from '@mailstep/design-system/ui/Blocks/CommonGrid/types'
import { useModal } from '@mailstep/design-system/ui/Blocks/Modal/hooks/useModal'
import useShallowRouting from './useShallowRouting'
import { x } from '@xstyled/styled-components'
import { getComparators } from './utils/getComparators'

type StyledCommonGridProps = {
  onExport?: GridExportProps['onExport']
  headersOnlyOption?: boolean
}

export type Props = GridProps & StyledCommonGridProps

export type PageGridProps = Omit<
  GridProps,
  'rowsData' | 'totalRowsCount' | 'columnsDefinitions' | 'actionColumnDefinition' | 'minColumnWidth' | 'columnLayout'
> &
  StyledCommonGridProps

const StyledCommonGrid: FC<Props> = ({ onExport, headersOnlyOption, gridSelectors, gridActions, ...props }) => {
  const { onOpen: onExportClick, isOpen: exportFormVisible, onClose: hideExport } = useModal()

  const { changePathOrSetPage, rowsPerPageValue } = useShallowRouting(gridActions, gridSelectors)

  return (
    <x.div h="calc(100% - 65px)">
      <CommonGrid
        processCheckedValues={onExport ? onExportClick : undefined}
        gridActions={gridActions}
        gridSelectors={gridSelectors}
        queryRowsParam={rowsPerPageValue}
        customPaginationHandler={changePathOrSetPage}
        comparators={getComparators()}
        {...props}
      />
      {!!onExport && exportFormVisible && (
        <GridExport
          onClose={hideExport}
          onExport={onExport}
          gridSelectors={gridSelectors}
          headersOnlyOption={headersOnlyOption}
        />
      )}
    </x.div>
  )
}

export default StyledCommonGrid
